import PropTypes from 'prop-types';
import moment from 'moment';

const defaultProps = {
  context: {
    pageUri: 'aibes.org',
    pageName: 'Asociación Iberoamericana de Scrum',
  },
};

const propTypes = {
  values: PropTypes.object.isRequired,
  cookie: PropTypes.string.isRequired,
  context: PropTypes.shape({
    pageUri: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
  }),
};

export default function getSubmitData(values, cookie = '', context = {}) {
  let fields = [];

  Object.keys(values).forEach((field) => {
    fields = [
      ...fields,
      {
        name: field,
        value: values[field],
      },
    ];
  });

  let contextFinal = {
    ...context,
  };

  if (cookie !== '' && cookie !== undefined) {
    contextFinal = {
      ...contextFinal,
      hutk: cookie,
    };
  }

  return {
    submittedAt: moment().valueOf(),
    fields,
    contextFinal,
  };
}

getSubmitData.defaultProps = defaultProps;
getSubmitData.propTpyes = propTypes;
